import axiosHttp from "services/axiosHttp";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BACKOFFICE_ORDER_REQUEST } from "../constants/apiPaths";

export const fetchOrderRequestApprovalQueue = createAsyncThunk(
	"orderRequests/fetchApprovalQueue",
	async ({ filters, page = 1, limit = 20, channel_id } = {}, { rejectWithValue }) => {
		try {
			const rangeStart = filters?.date_from || filters?.range?.[0]?.format?.("YYYY-MM-DD") || "";
			const rangeEnd = filters?.date_to || filters?.range?.[1]?.format?.("YYYY-MM-DD") || "";
			const params = new URLSearchParams({
				page,
				limit,
				...(channel_id ? { channel_id } : {}),
				...(filters?.keyword ? { keyword: filters.keyword } : {}),
				...(filters?.reference_code ? { distributor_code: filters.reference_code } : {}),
				...(rangeStart ? { date_from: rangeStart } : {}),
				...(rangeEnd ? { date_to: rangeEnd } : {}),
			});
			const response = await axiosHttp.get(`${BACKOFFICE_ORDER_REQUEST}/approval-queue?${params}`);
			return response.data?.data ?? response.data;
		} catch (err) {
			return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch approval queue");
		}
	}
);

const OrderRequestApprovalQueueSlice = createSlice({
	name: "OrderRequestApprovalQueueSlice",
	initialState: {
		isLoading: false,
		error: null,
		data: null,
		page: 1,
		total: 0,
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchOrderRequestApprovalQueue.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchOrderRequestApprovalQueue.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
				state.page = action.payload?.currentPage ?? action.payload?.current_page ?? action.payload?.page ?? 1;
				state.total = action.payload?.total ?? action.payload?.total_count ?? action.payload?.totalRows ?? 0;
			})
			.addCase(fetchOrderRequestApprovalQueue.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload || action.error?.message;
			});
	},
});

export default OrderRequestApprovalQueueSlice.reducer;

